import axios from "axios";
import "@/plugins/datetime";

const state = {
  checkup: {
    date: LuxonDateTime.local().toISO(),
    smoking: 0,
    lackVegetableAndFruit: 0,
    lackOfPhysicalActivity: 0,
    alcohol: 0,
    weight: 0.0,
    height: 0.0,
    waist: 0.0,
    systolicPressure: 0,
    diastolicPressure: 0,
    cholesterol: 0.0,
    bloodSugar: 0.0,
    uricAcid: 0.0,
    problem: "",
    suggestion: "",
    referralDate: "",
    referralReason: "",
  },
};

const actions = {
  getCheckup: (context, { userId, date }) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        url: context.rootGetters.baseUrl + `checkups/show/${userId}/${date}`,
      })
        .then((response) => {
          const data = response.data.data;
          context.commit("CHECKUP_UPDATE", data);
          resolve(response);
        })
        .catch((error) => {
          if (error.response.status == 404) {
            context.commit("CHECKUP_RESET");
          }
          reject(error);
        });
    });
  },
  createOrUpdateCheckup: (context, { userId, payload }) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: context.rootGetters.baseUrl + "checkups",
        data: {
          user_id: userId,
          date: LuxonDateTime.fromISO(payload.date).toFormat("yyyy-LL-dd"),
          smoking: payload.smoking,
          lack_vegetable_fruit: payload.lackVegetableAndFruit,
          lack_physical_activity: payload.lackOfPhysicalActivity,
          alcohol: payload.alcohol,
          weight: payload.weight,
          height: payload.height,
          waist: payload.waist,
          systolic_pressure: payload.systolicPressure,
          diastolic_pressure: payload.diastolicPressure,
          cholesterol: payload.cholesterol,
          blood_sugar: payload.bloodSugar,
          uric_acid: payload.uricAcid,
          problem: payload.problem,
          suggestion: payload.suggestion,
          referral_date: payload.referralDate
            ? LuxonDateTime.fromISO(payload.referralDate).toFormat("yyyy-LL-dd")
            : null,
          referral_reason: payload.referralReason,
        },
      })
        .then((response) => {
          const data = response.data.data;
          context.commit("CHECKUP_UPDATE", data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  resetCheckup: (context) => {
    context.commit("CHECKUP_RESET");
  },
};

const mutations = {
  CHECKUP_UPDATE: (state, checkup) => {
    state.checkup.date = LuxonDateTime.fromFormat(
      checkup.date,
      "yyyy-LL-dd"
    ).toISO();
    state.checkup.smoking = checkup.smoking;
    state.checkup.lackVegetableAndFruit = checkup.lack_vegetable_fruit;
    state.checkup.lackOfPhysicalActivity = checkup.lack_physical_activity;
    state.checkup.alcohol = checkup.alcohol;
    state.checkup.weight = checkup.weight;
    state.checkup.height = checkup.height;
    state.checkup.waist = checkup.waist;
    state.checkup.systolicPressure = checkup.systolic_pressure;
    state.checkup.diastolicPressure = checkup.diastolic_pressure;
    state.checkup.cholesterol = checkup.cholesterol;
    state.checkup.bloodSugar = checkup.blood_sugar;
    state.checkup.uricAcid = checkup.uric_acid;
    state.checkup.problem = checkup.problem;
    state.checkup.suggestion = checkup.suggestion;
    state.checkup.referralDate = checkup.referral_date
      ? LuxonDateTime.fromFormat(checkup.referral_date, "yyyy-LL-dd").toISO()
      : "";
    state.checkup.referralReason = checkup.referral_reason;
  },
  CHECKUP_RESET: (state) => {
    state.checkup.smoking = 0;
    state.checkup.lackVegetableAndFruit = 0;
    state.checkup.lackOfPhysicalActivity = 0;
    state.checkup.alcohol = 0;
    state.checkup.weight = 0.0;
    state.checkup.height = 0.0;
    state.checkup.waist = 0.0;
    state.checkup.systolicPressure = 0;
    state.checkup.diastolicPressure = 0;
    state.checkup.cholesterol = 0.0;
    state.checkup.bloodSugar = 0.0;
    state.checkup.uricAcid = 0.0;
    state.checkup.problem = "";
    state.checkup.suggestion = "";
    state.checkup.referralDate = "";
    state.checkup.referralReason = "";
  },
};

const getters = {
  checkup: (state) => state.checkup,
};

export default {
  state: state,
  getters,
  actions,
  mutations,
};
